module.exports = __webpack_public_path__ + "img/menu-on_04.2826c230.png";